<script setup>
defineProps(['item']);
</script>

<template>
    <div>
        <div class="text-subtitle-1 text-primary mb-3 font-weight-bold">
            <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
            {{ $t(item.title) }}
        </div>
        <div
            v-for="(data, i) in item.data"
            :key="i"
            class="d-flex justify-space-between"
        >
            <template v-if="data.value">
                <span class="text-subtitle-2">
                    {{ data.value }}
                </span>
            </template>
        </div>
    </div>
</template>
